<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1 style="font-family:Calisto MT; font-size:18pt; letter-spacing:1px; padding-top:75px; padding-bottom:0px;">About the Author</h1>
<p style="text-align: center;"> <img alt="auth" src="media/auth.JPG"/> </p>
<p style="text-indent:0em;">Graeme Cross has been raised in the Church, having parents who were ministers in the Salvation Army, and became a Christian in his youth. A devoted husband, father and grandfather. He is a qualified lawyer, who left that profession some years ago in response to the call of God on his life to work for the Church.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?31ef429c